import { useState } from "react";
import api from "@/lib/api";
import { autoTrackReferral } from "@/lib/referral";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", { email });
      // Auto-track referral if ?ref= was captured earlier
      autoTrackReferral(email, "", "newsletter").catch(() => {});
      setDone(true);
      toast.success("धन्यवाद! आप सब्सक्राइब हो गये।");
      setEmail("");
    } catch(err) { toast.error("सब्सक्रिप्शन नहीं हो पाया"); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500"/>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="ईमेल पता" required
          className="pl-9 bg-white border-slate-300 text-slate-900 placeholder:text-slate-400"
          data-testid="newsletter-email"/>
      </div>
      <Button type="submit" disabled={busy || done} className="bg-[#EA580C] hover:bg-[#c2410c] text-white" data-testid="newsletter-submit">
        {done ? <CheckCircle2 className="w-4 h-4"/> : (busy ? "…" : "जुड़ें")}
      </Button>
    </form>
  );
}
